export default __webpack_public_path__ + "static/media/avatarAlmir.c0d18bba.jpg";